<template>
    <div>
      <div class="home" :class="{loaded}">
          <!-- <a href="https://www.giraffas.com.br" target="_blank"><img class="logo" :src="logo" alt=""></a> -->
          <!-- <a href="https://sejaflow.com.br/" target="_blank"> -->
          <a href="<>HOME_PAGE_URL<>" target="_blank">
            <img class="logo" :src="siteMetadata?.mainLogo || logo" alt="">
          </a>
          <h2 :style="`color: ${getIdealTextColor()}`" v-text="title"></h2>
          <h1 :style="`color: ${getIdealTextColor()}`" v-text="mainText"></h1>
          <form @submit.prevent="pushConsData()">
              <div class="form ">
              <FormFieldList :fields="mainFields" @changeEvent="changeEvent"></FormFieldList>
              </div>
              <div class="form no-margin">
                  <FormFieldList :fields="fields" @changeEvent="changeEvent"></FormFieldList>
              </div>
              <div class="form footer-form">
                <!-- <a href="https://sejaflow.com.br/" target="_blank"><img class="logo bt" :src="siteMetadata?.footerLogo || logo2" alt=""></a> -->
                <a href="<>HOME_PAGE_URL<>" target="_blank"><img class="logo bt" :src="siteMetadata?.footerLogo || logo2" alt=""></a>
                <FormFieldList :fields="footerFields" @changeEvent="changeEvent"></FormFieldList>
              </div>
          </form>
      </div>
      <div class="modal-overlay" @click="modal.show = false" v-if="modal.show"></div>
      <div class="modal" v-if="modal.show" :style="`color: ${getIdealTextColor()}`">
          <div class="message" v-text="modal.message"></div>
          <button v-text="'OK'" @click="modal.show = false"></button>
      </div>
    </div>
  </template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FormFieldList from '@/components/FormFieldList.vue'
import { idealTextColor, validateCPF } from '@/controllers/libs/Util.js'
import { cidades } from '@/controllers/libs/Cidades.js'
import { estados } from '@/controllers/libs/Estados.js'
import ApiCom from '@/controllers/libs/ApiCom.js'
import { config } from '@/config/config'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'HomeView',
    components: {
        FormFieldList
    },
    props: {
        client: String
    },
    data () {
        return {
            loaded: false,
            logo: '',
            logo2: '',
            title: 'Crie sua Conta',
            mainText: 'Complete seu cadastro e receba recomendações e promoções personalizadas!',
            isLandPage: false,
            modal: {
                show: false,
                message: ''
            },
            mainFields: [
                [
                    {
                        label: 'CPF',
                        type: 'tel',
                        placeHolder: '000.000.000-00',
                        mask: '###.###.###-##',
                        change: 'cpfValidation',
                        model: 'cpf'
                    }
                ],
                [
                    {
                        label: 'Telefone Celular',
                        type: 'tel',
                        placeHolder: '(00) 00000 - 0000',
                        mask: '(##) #####-####',
                        required: true,
                        change: 'getConsdata',
                        model: 'phone'
                    }
                ],
                [
                    {
                        label: 'Nome Completo',
                        type: 'text',
                        placeHolder: 'Digite Aqui',
                        required: true,
                        model: 'name'
                    }
                ]
            ],
            fields: [
                [
                    {
                        label: 'E-mail',
                        type: 'email',
                        placeHolder: 'exemplo@exemplo.com',
                        model: 'email'
                    },
                    {
                        label: 'Data de Nascimento',
                        type: 'date',
                        placeHolder: 'dd/mm/aaaa',
                        model: 'birthday'
                    },
                    {
                        label: 'Sexo',
                        type: 'dropdown',
                        options: [
                            'Feminino',
                            'Masculino'
                        ],
                        model: 'gender'
                    }
                ],
                [
                    {
                        label: 'Cep',
                        type: 'tel',
                        placeHolder: '00000-000',
                        mask: '#####-###',
                        change: 'findCep',
                        model: 'cep'
                    },
                    {
                        label: 'Endereço',
                        type: 'text',
                        model: 'street'

                    },
                    {
                        label: 'Bairro',
                        type: 'text',
                        model: 'neighborhood'
                    }
                ],
                [
                    [
                        {
                            label: 'Estado',
                            type: 'dropdown',
                            options: estados.map(c => c.Sigla),
                            model: 'state'
                        },
                        {
                            label: 'Cidade',
                            type: 'dropdown',
                            options: cidades.map(c => c.Nome),
                            model: 'city'
                        }
                    ],
                    [
                        {
                            label: 'Número',
                            type: 'text',
                            model: 'addressNumber'
                        },
                        {
                            label: 'Complemento',
                            type: 'text',
                            model: 'complement'
                        }
                    ]
                ]
            ],
            footerFields: [
                [
                    {
                        type: 'checkbox',
                        label: 'Li e concordo com os Termos de Privacidade',
                        link: '#',
                        required: true,
                        model: 'eula'
                    },
                    {
                        type: 'button',
                        label: 'Enviar'
                    }
                ]
            ]
        }
    },
    computed: {
        ...mapState(['formModel']), ...mapGetters(['siteMetadata'])
    },
    mounted () {
        let clientCode = null
        let consumerCode = null
        let nrorg = null
        if (JSON.stringify(this.$route.query) === '{}' && config.isSaas !== 'true') {
            this.isLandPage = true
            this.getClientLayout(nrorg)
        } else {
            try {
                clientCode = JSON.parse(atob(this.$route.query.id)).clientCode
                consumerCode = JSON.parse(atob(this.$route.query.id)).consumerCode
                nrorg = JSON.parse(atob(this.$route.query.id)).nrorg
                this.getClientLayout(nrorg)
            } catch (error) {
                console.log(error)
            }

            this.$store.state.formModel = { clientCode, consumerCode, nrorg }
            this.getConsdata()
        }
    },
    watch: {
        '$store.state.formModel.cep': function (newCep, oldCep) {
            this.$store.state.formModel.street = null
            this.$store.state.formModel.neighborhood = null
            this.$store.state.formModel.state = null
            this.$store.state.formModel.city = null
            this.$store.state.formModel.addressNumber = null
            this.$store.state.formModel.complement = null
            this.findCep()
        }
    },
    methods: {
        ...mapActions(['updateMetaData']),
        getIdealTextColor: function () {
            return idealTextColor()
        },
        changeEvent: function (eventData) {
            this[eventData.change] && this[eventData.change](eventData)
        },
        cpfValidation: function () {
            if (!this.$store.state.formModel?.cpf || this.$store.state.formModel?.cpf?.length === 0) {
                return true
            }
            if (!validateCPF(this.$store.state.formModel?.cpf)) {
                this.modal.show = true
                this.modal.message = 'Por favor insira um cpf válido!'
                return false
            }
            return true
        },
        unknowUserError: function () {
            this.modal.show = true
            this.modal.message = this.siteMetadata?.saleNotFoundTxt || 'Você ainda não realizou nenhuma compra em nossas unidades. \nVá a uma de nossas lojas e participe!'
            this.$router.push({ name: 'about', query: { message: this.modal.message } })
        },
        unknowError: function () {
            this.modal.show = true
            this.modal.message = 'Um erro desconhecido aconteceu, tente novamente mais tarde.'
            this.$router.push({ name: 'about', query: { message: this.modal.message } })
        },
        userDoubleError: function () {
            this.modal.show = true
            this.modal.message = this.siteMetadata?.registeredTxt || 'Você já está cadastrado e em breve receberá recomendações e promoções personalizadas!'
            this.$router.push({ name: 'about', query: { message: this.modal.message } })
        },
        registerSuccess: function () {
            this.modal.show = true
            this.modal.message = this.siteMetadata?.successTxt || 'Parabéns cadastro realizado com sucesso!!'
            this.$router.push({ name: 'about', query: { message: this.modal.message } })
        },
        apiError: function (message) {
            if (message === 'Erro. Consumidor não encontrado.') {
                this.unknowUserError()
            } else if (message === 'Erro. Consumidor já atualizado.') {
                this.userDoubleError()
            } else {
                this.modal.show = true
                this.modal.message = message
                this.$router.push({ name: 'about', query: { message } })
            }
        },
        findCep: function () {
            const cep = this.$store.state.formModel?.cep
            const sf = this
            if (cep && cep.length >= 9) {
                axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                    .then(function (response) {
                        const data = response.data
                        if (data.erro) throw new Error('Cep inválido')
                        sf.$store.state.formModel.street = data.logradouro
                        sf.$store.state.formModel.neighborhood = data.bairro
                        sf.$store.state.formModel.state = data.uf
                        sf.$store.state.formModel.city = data.localidade
                    })
                    .catch(function (error) {
                        sf.modal.show = true
                        sf.modal.message = error.message
                    })
            }
        },
        getClientLayout: async function (nrorg) {
            const retailData = (await ApiCom.getClientLayout({}, nrorg))?.root?.data
            if (retailData) {
                this.updateMetaData(retailData)
                this.footerFields[0][0].link = retailData.urlTermAdesao
                const root = document.querySelector(':root')
                root.style.setProperty('--primaryColor', '#' + retailData.primaryColor)
                root.style.setProperty('--secundaryColor', '#' + retailData.secondaryColor)
                root.style.setProperty('--footerColor', '#' + retailData.footerColor)
                root.style.setProperty('--buttonColor', '#' + retailData.buttonColor)
            }
            this.loaded = true
        },
        getConsdata: function () {
            if (!this.isLandPage) {
                const sf = this
                ApiCom.getConsumer({
                    clientCode: this.$store.state.formModel.clientCode,
                    consumerCode: this.$store.state.formModel.consumerCode
                }, this.$store.state.formModel.nrorg).then(c => {
                    if (!c) {
                        throw new Error('UNKNOW_USER_ERROR')
                    } else if (c?.root?.error !== 'false') {
                        sf.apiError(c?.root?.message)
                        return false
                    }
                    this.$store.state.formModel.phone = c.root.data.phone
                }).catch(e => {
                    if (e.message === 'USER_DOUBLE_ERROR') {
                        sf.userDoubleError()
                    } else {
                        sf.unknowUserError()
                    }
                })
            }
        },
        pushConsData: function () {
            const sf = this
            const data = this.$store.state.formModel
            const cleanedData = Object.fromEntries(Object.entries(data).filter(([key, value]) => value !== null && value !== undefined))

            this.footerFields[0][1].disabled = true

            if (!this.cpfValidation()) return false
            if (cleanedData.birthday) cleanedData.birthday = moment(cleanedData.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')

            if (this.isLandPage) {
                ApiCom.registerConsumer(cleanedData, this.$store.state.formModel.nrorg).then(s => {
                    if (s.root.error === 'true') {
                        sf.userDoubleError()
                    } else {
                        sf.registerSuccess()
                    }
                }).catch(e => {
                    console.log(e)
                    sf.unknowError()
                })
            } else {
                ApiCom.getConsumer({
                    clientCode: this.$store.state.formModel.clientCode,
                    consumerCode: this.$store.state.formModel.consumerCode
                }, this.$store.state.formModel.nrorg).then(r => {
                    if (!r) {
                        throw new Error('UNKNOW_USER_ERROR')
                    }
                    if (r.root.error !== 'false') {
                        sf.apiError(r.root.mesage)
                        return false
                    }
                    const cli = r.root.data
                    ApiCom.updateConsumer({ ...cli, ...cleanedData }, this.$store.state.formModel.nrorg).then(e => {
                        // sf.modal.show = true
                        // sf.modal.message = 'Parabéns cadastro realizado com sucesso!!'
                        // // sf.$store.state.formModel.birthday = moment(sf.$store.state.formModel.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD')
                        // sf.$router.push({ name: 'about', query: { message: sf.modal.message } })
                        sf.registerSuccess()
                    })
                }).catch(e => {
                    if (e.message === 'UNKNOW_ERROR') {
                        sf.unknowError()
                    } else {
                        sf.unknowUserError()
                    }
                })
            }

            this.footerFields[0][1].disabled = false
            return false
        }
    }
}
</script>

  <style lang="less">
   @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

  input[type="date"]
  {
      display:block;
      -webkit-appearance: textfield;
      -moz-appearance: textfield;
      min-height: 1.2em;
  }

  .modal-overlay {
      background: black;
      opacity: .5;
      position: fixed;
      top: 0;left: 0;
      right: 0;bottom: 0;
      z-index: 5;
  }
  .modal {
      position: fixed;
      display: block;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 320px;
      background: var(--primaryColor);
      padding: 30px;
      border-radius: 5px;
      z-index: 6;
      button {
          position: relative;
          display: block;
          margin: 10px auto 0 auto;
          width: 100px;
          padding: 5px 0;
      }
  }
  .home {
      padding: 40px 0 0 0;
      min-height: calc(100vh - 70px);
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      &:not(&.loaded):before {
          content: '';
          background: #fff;
          position: fixed;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
        }
       &:not(&.loaded):after {
        content: '';
        display: block;
        width: 40px;
        height: 40px;
        margin: 8px;
        border-radius: 50%;
        border: 4px solid #000;
        border-color: #000 transparent #000 transparent;
        animation: spin 1.2s linear infinite;
        position: absolute;
        z-index: 5;
       }
      .logo {
          object-fit: contain;
          max-width: 80vw;
          // max-height: 70px;
          max-height: 115px;
          display: block;
          margin: auto;
          &.bt {
            max-height: 150px;
            max-width: 100%;
          }
          &.thumb {
              pointer-events: none;
              max-height: 200px;
              margin: -150px 0 0 auto;
          }
      }
  }
  h1, h2{
      color: #FFF;
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      margin-bottom: 15px;
  }
  h2 {
      color: rgb(123 70 43);
      font-size: 50px;
      margin-top: 15px;
  }
  form {
    width: 1080px;
    max-width: 80%;
  }
  .form {
      display: block;
      max-width: 80vw;
    //   margin: auto;
      display: grid;
      grid-template-columns: repeat(3, calc(33% - 20px));
      grid-column-gap: 30px;
      padding: 15px 0;
      &.main-form{
          display: block;
          border: solid 1px rgba(255, 255, 255, .5);
          border-left: none;
          border-right: none;
          .form-item-column {
              display: grid;
              grid-template-columns: repeat(3, calc(33% - 20px));
              grid-column-gap: 30px;
          }
      }
      .form-item-column {
          position: relative;
          font-size: 20px;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: form-item-column;
          align-items: stretch;
          label {
              font-weight: 700;
              font-size: 20px;
          }
          input, select {
              margin-top: 10px;
              width: calc(100% - 30px);
              margin-bottom: 15px;
              border-radius: 10px;
              border: 1px solid var(--secundaryColor);
              background: #FFF;
              // padding: 15px;
              padding-left: 15px;
              height: 47px;
          }
          select {
              width: calc(100% - 15px);
          }
          .field-item.duo-item {
              display: grid;
              grid-template-columns: 40% calc(60% - 0px);
              grid-column-gap: 0px;
          }
          .field-item.checkbox {
              width: 100%;
              display: flex;
              flex-direction: row-reverse;
              flex-wrap: nowrap;
              align-content: center;
              justify-content: center;
              align-items: center;
              label {
                  font-size: 16px;
              }
              .field-item-input.checkbox input{
                  width: 30px;
              }
          }
          .field-item.button {
              button {
                  margin: auto;
                  display: block;
                  border-radius: 11px;
                  border: 2px solid #FFF;
                  background: var(--buttonColor);
                  width: 248px;
                  height: 48px;
                  color: #FFF;
                  text-align: center;
                  font-size: 19px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;
                  text-transform: uppercase;
                  text-align: center;
                  cursor: pointer;
                &:hover {
                    background: var(--secundaryColor);
                }
              }
          }
      }
      &.footer-form {
        display: grid;
        grid-template-columns: 30% 70%;
      }
      &.no-margin{
        margin: 0;
        padding: 0;
      }
  }

  @media (max-width:960px) {
    form {
        width: auto
    }
      .form {
          max-width: 100%;
        //   padding: 0 15px;
          display: block;
          &.main-form {
              margin: 15px 0;
              padding: 15px;
              .form-item-column {
                  display: block;
              }
          }
          .form-item-column .field-item {
              &.button {
                  position: relative;
                  bottom: 0;
                  margin: auto;
                  padding-bottom: 30px;
                  button {
                      display: block;
                      margin: 30px auto 0 auto;
                  }
              }
              &.duo-item {
                  grid-template-columns: 40% calc(60% - 15px);
                  grid-column-gap: 15px;
              }
          }
          .form-item-column input {
                  width: calc(100% - 15px);
          }
          .form-item-column select {
              width: 100%;
          }
          &.footer-form {
            display: flex;
            flex-direction: column-reverse;
        }
      }
    .home .logo.thumb {
        margin: -115px 0 0 auto;
    }
  }
  </style>
